import {
  ArrowLeft,
  Check,
  CircleAlert,
  CircleCheckBig,
  CircleX,
  Clock,
  Eye,
  FileText,
  Headset,
  Link as LinkIcon,
  MessageSquare,
  Pause,
  Play,
  Rocket,
  RotateCw,
  Send,
  Shuffle,
  TriangleAlert,
} from 'lucide-react';

import type { AparenciaMarco, TipoMarco, TomMarco } from '../types/negociacaoMarcoTypes';

export const APARENCIA_PADRAO: AparenciaMarco = { icone: Clock, tom: 'brand' };

export const APARENCIA_POR_TIPO: Record<TipoMarco, AparenciaMarco> = {
  PRIMEIRO_CONTATO_ENVIADO: { icone: Rocket, tom: 'brand' },
  NOVA_TENTATIVA_CONTATO: { icone: Clock, tom: 'brand' },
  CONTATO_CANAL_ALTERADO: { icone: Clock, tom: 'brand' },
  PRIMEIRO_CONTATO_FALHOU: { icone: TriangleAlert, tom: 'erro' },
  CONTRAPARTE_RESPONDEU: { icone: MessageSquare, tom: 'brand' },
  OFFER_SENT: { icone: Send, tom: 'brand' },
  OFFER_RECEIVED: { icone: Shuffle, tom: 'brand' },
  NEGOCIACAO_PAUSADA: { icone: Pause, tom: 'brand' },
  NEGOCIACAO_RETOMADA: { icone: Play, tom: 'brand' },
  ATENDIMENTO_HUMANO_ACIONADO: { icone: Headset, tom: 'brand' },
  AUTOMATION_RESUMED_DIRECTED: { icone: RotateCw, tom: 'brand' },
  HUMAN_SUPPORT_CLOSED: { icone: RotateCw, tom: 'brand' },
  CONTRACT_SENT: { icone: LinkIcon, tom: 'brand' },
  CONTRACT_SEND_FAILED: { icone: TriangleAlert, tom: 'erro' },
  ENVIO_VISUALIZADO: { icone: Eye, tom: 'brand' },
  CONTRACT_SIGNED: { icone: CircleCheckBig, tom: 'brand' },
  SIGNATURE_STALLED: { icone: Clock, tom: 'brand' },
  AGREEMENT_FORMALIZED: { icone: CircleCheckBig, tom: 'brand' },
  CASO_ENCERRADO_ACORDO_IA: { icone: CircleCheckBig, tom: 'brand' },
  CASO_ENCERRADO_ACORDO_MANUAL: { icone: CircleCheckBig, tom: 'brand' },
  CASO_ENCERRADO_DESISTENCIA: { icone: CircleX, tom: 'brand' },
  CASO_ENCERRADO_CANCELAMENTO: { icone: FileText, tom: 'brand' },
  CASO_ENCERRADO_TIMEOUT: { icone: Clock, tom: 'brand' },
  CASO_ENCERRADO_FALHA_TECNICA: { icone: TriangleAlert, tom: 'erro' },
  CASE_CLOSED: { icone: FileText, tom: 'brand' },
  DECISION_MADE: { icone: CircleX, tom: 'brand' },
  CASE_REOPENED: { icone: ArrowLeft, tom: 'brand' },
  MESSAGE_DELIVERY_FAILED: { icone: TriangleAlert, tom: 'erro' },
  MENSAGEM_REENVIADA: { icone: Check, tom: 'brand' },
  SCHEDULED: { icone: Clock, tom: 'brand' },
  SCHEDULED_MESSAGES_CANCELLED: { icone: Clock, tom: 'brand' },
  CASE_CREATED: { icone: Rocket, tom: 'brand' },
  MESSAGE_SENT: { icone: Send, tom: 'brand' },
  MESSAGE_RECEIVED: { icone: MessageSquare, tom: 'brand' },
  MEDIATION_SUGGESTED: { icone: MessageSquare, tom: 'brand' },
  PAYMENT_UPDATE: { icone: Check, tom: 'brand' },
  MARCO_NAO_RECONHECIDO: { icone: CircleAlert, tom: 'brand' },
};

export function aparenciaDoMarco(tipo: string): AparenciaMarco {
  return Object.hasOwn(APARENCIA_POR_TIPO, tipo)
    ? APARENCIA_POR_TIPO[tipo as TipoMarco]
    : APARENCIA_PADRAO;
}

export const CLASSES_POR_TOM: Record<TomMarco, { icone: string; fundo: string }> = {
  brand: { icone: 'text-brand-600', fundo: 'bg-marco-icone-bg' },
  erro: { icone: 'text-error-600', fundo: 'bg-error-50' },
};
